/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { CountriesJson, CurriculumResponse, HobbiesResponse, MajorResponse, Nationality, StudyLevelResponse } from '../models/common.model';
import { environment } from '../../environments/environment';
import { StudentUserResponse } from '../models/auth.model';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  selectedLanguage: BehaviorSubject<string> = new BehaviorSubject<string>('en');

  removeEmptyKeys(obj: any): any {
    return Object.fromEntries(
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      Object.entries(obj).filter(([_, value]) => value !== null && value !== undefined && value !== '')
    );
  }

  constructor(private http: HttpClient) { }

  getCountries(): Observable<Array<CountriesJson>> {
    return this.http.get<Array<CountriesJson>>('assets/countryLangJson/countries.json');
  }

  getCities(country: string): Observable<any> {
    return this.http.get<any>('assets/countryLangJson/city.json').pipe(
      map((data: any[]) => {
        return data.find((item) => item.country === country);
      })
    );
  }

  getNationality(): Observable<Array<Nationality>> {
    return this.http.get<Array<Nationality>>('assets/countryLangJson/nationality.json');
  }

  getLanguages(country: string): Observable<any> {
    return this.http.get<any>('assets/countryLangJson/languages.json').pipe(
      map((data: any[]) => {
        return data.find((item) => item.country === country);
      })
    );
  }

  getAllLanguages(): Observable<any> {
    return this.http.get<any>('assets/countryLangJson/allLanguages.json').pipe(
      map(res => res));
  }

  getHobbies(): Observable<HobbiesResponse> {
    return this.http.get<{data: HobbiesResponse}>(`${environment.base_url}hobbies`).pipe(map(res => res.data));
  }

  getStudyLevels(): Observable<StudyLevelResponse> {
    return this.http.get<{data: StudyLevelResponse}>(`${environment.base_url}studyLevels`).pipe(map(res => res.data));
  }

  getCurriculum(): Observable<CurriculumResponse> {
    return this.http.get<{data: CurriculumResponse}>(`${environment.base_url}curriculam`).pipe(map(res => res.data));
  }

  getMajors(): Observable<MajorResponse> {
    return this.http.get<{data: MajorResponse}>(`${environment.base_url}major`).pipe(map(res => res.data));
  }

  getUserById(id: string): Observable<StudentUserResponse> {
    return this.http.get<{data: StudentUserResponse}>(`${environment.base_url}user/getUserById?id=${id}`).pipe(map(res => res.data));
  }

}
